<template>
    <div class="sos-marker">
        <span class="sos-marker__ping"></span>
        <span class="sos-marker__badge">SOS</span>
    </div>
</template>
<script>
export default {};
</script>
<style scoped>
.sos-marker {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 2.5rem;
    height: 2.5rem;
    cursor: pointer;
}
.sos-marker__ping {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    background-color: #ef4444;
    border-radius: 9999px;
    opacity: 0.6;
    animation: sos-ping 1.2s cubic-bezier(0, 0, 0.2, 1) infinite;
}
.sos-marker__badge {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 2.25rem;
    height: 2.25rem;
    font-size: 11px;
    font-weight: 800;
    letter-spacing: 0.02em;
    color: #ffffff;
    background-color: #dc2626;
    border: 2px solid #ffffff;
    border-radius: 9999px;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.3);
}
@keyframes sos-ping {
    75%,
    100% {
        transform: scale(1.9);
        opacity: 0;
    }
}
</style>
